import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import "./toggle-control.scss";

const ToggleControl = ({
  id,
  type,
  value,
  children,
  checked,
  text,
  onChange,
  boxed,
  className,
  name,
  disabled,
  ...props
}) => {
  const classes = classnames(
    "toggle-control",
    {
      "toggle-control--checked": checked,
      "toggle-control--boxed": boxed,
      "toggle-control--disabled": disabled,
    },
    `toggle-control--${type}`,
    className
  );
  return (
    <label htmlFor={id} className={classes} {...props}>
      <input
        id={id}
        type={type}
        value={value}
        checked={checked}
        onChange={onChange}
        name={name}
        disabled={disabled}
      />
      <span className="toggle-control__control" />
      <div className="toggle-control__content">
        <div className="toggle-control__label body-copy">{text}</div>
        {children && <div className="toggle-control__additional">{children}</div>}
      </div>
    </label>
  );
};

export const ToggleControlPropTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number]).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]),
  text: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.string])
    .isRequired,
  className: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  boxed: PropTypes.bool,
  name: PropTypes.string,
};

ToggleControl.propTypes = {
  ...ToggleControlPropTypes,
  type: PropTypes.string.isRequired,
};

export default ToggleControl;
